import { EventEmitter, Output, ViewChild, Directive } from "@angular/core";
import { ModalComponent } from "../+shared/components/modals/modal.component/modal.component";

/**
 * 
 * Base class for the general modal sub component.
 *
 * */
@Directive()
export abstract class ModalBase
{
    @ViewChild("modal", { static: true })
    modal: ModalComponent;

    @Output()
    public onClose = new EventEmitter();

    public open(closeable:boolean = true): void
    {
        if(!this._isOpen) {
        this._isOpen = true;
        this.modal.open(closeable);
        }
    }

    public close(): void
    {
        this.modal.close();
        this._isOpen = false;
        this.onClose.emit();
    }

    protected isOpen(): boolean
    {
        return this._isOpen;
    }

    private _isOpen = false;
}
